<script>
  import "./app.css";
  import "./firebaseConfig.js";
  import Router from "svelte-spa-router";
  import Footer from "./Footer.svelte";
  import { routes } from "./routes.js";
  import { fp } from "./stores/fingerprint.js";
  import { station } from "./stores/station.js";
  import { bgColor, changeColor } from "./stores/background_color";
  import "./tailwind.css";

  let loading = true;

  fp.subscribe(async (_fp) => {
    if (_fp) {
      await new Promise((resolve) => setTimeout(resolve, 500));
      loading = false;
    }
  });
</script>

<div class="bg" style="background: {$bgColor};">
  {#if loading}
    <h2>Loading...</h2>
  {:else}
    <Router {routes}></Router>
    <Footer></Footer>
  {/if}
</div>

<style>
  :global(body, html) {
    overflow-x: hidden;
    padding: 0;
    margin: 0;
    font-family: "Paytone One", Arial, Helvetica, sans-serif;
    background: white;
  }

  h2 {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 30px;
    color: white;
    width: 100%;
    height: 100%;
    font-weight: 100;
    position: fixed;
    font-family: "Dosis";
    font-family: "Catamaran";
    font-family: "Luckiest Guy";
    font-family: "Paytone One";
  }
</style>
